module.exports = __webpack_public_path__ + "static/media/ic_shape_selected.d4cb493e.svg";